import { Card, CardContent, CardHeader, FormControl, Grid, MenuItem, Select } from '@mui/material'
import ArgonBox from 'components/ArgonBox'
import ArgonTypography from 'components/ArgonTypography'
import MapMultiple from 'examples/Maps/MapMultiple'
import { CustomDescrypt } from 'global/func'
import { postDataWithResponse } from 'global/postFunc'
import React, { useEffect, useState } from 'react'
import { decodeToken } from 'react-jwt'
import userStore from 'store/userStore'

const LokasiPekerjaan = () => {
    const { user, addReq, tahunAnggaran } = userStore(state => ({ user: state.user, addReq: state.addReq, tahunAnggaran: state.tahunAnggaran }));
    const decryptedUser = (user === null || user === undefined || user === '') ? "" : JSON.parse(CustomDescrypt(user));
    const decodedUser = decodeToken(decryptedUser)

    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)

    const [basemap, setBasemap] = useState('streets-navigation-vector')

    useEffect(() => {
        reqPaket()
        console.log(data);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const reqPaket = () => {
        addReq()
        setLoading(true)
        postDataWithResponse(
            '/admin-opd/komponen-belanja/off-site',
            {
                kd_pd: decodedUser.kd_pd,
                ta: tahunAnggaran.ta,
            },
            decryptedUser,
            (res) => {
                // console.log(res);
                setData(res)
                setLoading(false)
            },
            (res) => {
                console.log(res)
                setLoading(false)
            }

        )
    }

    return (
        <ArgonBox pys={3}>
            <ArgonBox>
                <Grid container spacing={2}>
                    <Grid item xs={12} lg={3}>
                        <Card>
                            <CardHeader
                                title={
                                    <ArgonTypography component="label" variant="subtitle2" fontWeight="bold">
                                        Filter
                                    </ArgonTypography>
                                }
                            />
                            <CardContent sx={{ height: '100%' }}>
                                <ArgonBox mb={1}>
                                    <ArgonBox mb={1} ml={0.5}>
                                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                            Basemap Style
                                        </ArgonTypography>
                                    </ArgonBox>
                                    <FormControl fullWidth>
                                        <Select
                                            placeholder="Select year"
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={basemap}
                                            onChange={(e) => {
                                                setBasemap(e.target.value)
                                            }}
                                        >
                                            <MenuItem key='0' value='streets-navigation-vector'>Default</MenuItem>
                                            <MenuItem key='1' value='satellite'>Satellite</MenuItem>
                                            <MenuItem key='2' value='dark-gray-vector'>Dark</MenuItem>
                                            <MenuItem key='3' value='topo'>Topografi</MenuItem>
                                            <MenuItem key='4' value='streets'>Street</MenuItem>
                                        </Select>
                                    </FormControl>
                                </ArgonBox>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} lg={9}>
                        <Card sx={{ height: '800px' }}>
                            <MapMultiple
                                data={data}
                                basemap={basemap}
                            />
                        </Card>
                    </Grid>
                </Grid>
            </ArgonBox>
        </ArgonBox>
    )
}

export default LokasiPekerjaan